// User authority constants - matching Angular's user-authorities.constants.ts
export const ROLE_USER = 'ROLE_USER';
export const ROLE_USER_ADMIN = 'ROLE_USER_ADMIN';
export const ROLE_PROGRAM_ADMIN = 'ROLE_PROGRAM_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN';

// User-friendly role labels for display
export const ROLE_LABELS: Record<string, string> = {
    [ROLE_USER]: 'User',
    [ROLE_USER_ADMIN]: 'User Admin',
    [ROLE_PROGRAM_ADMIN]: 'Program Admin',
    [ROLE_ADMIN]: 'Admin',
};

// Helper function to get friendly role label
export const getRoleLabel = (role: string): string => ROLE_LABELS[role] || role;

// Authority groups for route protection
export const AUTHORITIES_ADMIN = [ROLE_ADMIN, ROLE_USER_ADMIN];
export const AUTHORITIES_ALL = [ROLE_USER, ROLE_USER_ADMIN, ROLE_PROGRAM_ADMIN, ROLE_ADMIN];
export const AUTHORITIES_USER = [ROLE_USER_ADMIN, ROLE_USER];

// Pagination defaults
export const ITEMS_PER_PAGE = 20;
export const MAX_SIZE = 5;

// Storage keys
export const STORAGE_KEYS = {
    SUBSCRIBER_ID: 'jhi-subscriberId',
    REMEMBER_ME: 'jhi-rememberMe',
    IMPERSONATE_USERNAME: 'jhi-usernameToImpersonate',
    SUBSCRIBER_SWITCHED: 'jhi-subscriberSwitched',
} as const;

// API endpoints
export const API_ENDPOINTS = {
    AUTHENTICATION: '/api/authentication',
    LOGOUT: '/api/logout',
    ACCOUNT: '/api/account',
    ACTIVATE: '/api/activate',
    PASSWORD_RESET_INIT: '/api/account/reset-password/init',
    PASSWORD_RESET_FINISH: '/api/account/reset-password/finish',
    PASSWORD_CHANGE: '/api/account/change-password',
    SUBSCRIBERS: '/api/subscribers',
    IMPERSONATE: '/api/login/impersonate',
} as const;
